import React, { useEffect } from "react";
import { useMembership } from "../context/membershipContext";
import { useHistory } from "react-router-dom";
import { signoutRedirect } from "../services/userService";
import { welcomeText } from "../data/config";
import Spinner from "./ui/Spinner";

const Logout = (props) => {
  const { dispatch } = useMembership();
  const history = useHistory();

  const isMobile = window.matchMedia("(max-width: 600px)").matches;
  const marginTop = {
    marginTop: isMobile ? "20px" : "",
  };

  // Run once on mount to clear session state and initiate sign-out.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    try {
      //Clear countries list out of local storage
      localStorage.removeItem("aanp_countries");
      //Remove join/renew date from session storage
      sessionStorage.removeItem("session_membership");
      dispatch({ type: "resetMembership" });

      //Log out of IdentityServer
      signoutRedirect();
    } catch (error) {
      history.push("/error");
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

return (
    <>
      <div style={{ position: "relative" }}>
        <div className="grid-container" id={isMobile ? "join-banner" : ""}>
          <div className="grid-x grid-margin-x align-center">
            <div className="cell large-7 text-center">
              <div style={{ paddingBottom: "4rem" }}>{welcomeText}</div>
            </div>
          </div>
        </div>
      </div>
      <div className="grid-container join-content">
        <div className="grid-x grid-margin-x align-center">
          <div className="cell large-10 xlarge-9">
            <div className="box">
              <div className="page is-active is-loaded" style={marginTop}>
                <div className="box-header">
                  <legend>There was an issue with your network connection.</legend>
                </div>
                <div className="box-content">
                  <fieldset className="box-section">
                    <h3 className="box-section-heading">
                      You will be redirected to the login page in order to log back in to your AANP account.
                    </h3>
                    <p className="input-wrapper">
                    If you continue to have an issue please
                      contact our membership department at (512) 505-0242 or submit an online request for assistance{" "}
                      <a href="https://ask.aanp.org/membership">
                        here
                      </a>
                    </p>

                    <Spinner />
                  </fieldset>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};export default Logout;
